import { Modal } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { postRequestByAuth } from "../../../function/helper";
import Laoding from "../../Loading";
import BankAccountBox from "./BankAccountBox";
import { Fragment, useState } from "react";
import NewBankAccount from "../../../pages/account/components/wallet/components/NewBankAccount";
import SelectBankAccountGrid from "./SelectBankAccountGrid";
import Swal from "sweetalert2";

function ChooseBankAccountForOrder({ onClose, onChoose, senderAddressId }) {
  const [bankAccount, setBankAccount] = useState(null);

  const handleBankAccountPick = () => {
    if (!bankAccount) {
      Swal.fire({
        icon: "warning",
        text: "انتخاب حساب بانکی برای مرسولات COD الزامی است",
        confirmButtonColor: "gray",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    onChoose(bankAccount);
  };

  const { isFetching } = useQuery({
    queryKey: ["getBySenderAddressId"],
    queryFn: () =>
      postRequestByAuth("/bank-account/v1/getBySenderAddressId", {
        senderAddressId,
      }).then(res => {
        if (res && res.status === 200) {
          setBankAccount(res.data.data.bankAccount);
        }

        return null;
      }),

    retry: 0,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
  });

  return (
    <Modal show centered className="rtl-all modal-bootstrap" size="lg">
      <Modal.Header>
        <h5 className="mb-0">انتخاب حساب بانکی فرستنده برای مبلغ COD مرسوله</h5>
      </Modal.Header>

      <Modal.Body>
        {isFetching && <Laoding />}

        {!isFetching && (
          <Fragment>
            {bankAccount && <BankAccountBox item={bankAccount} />}
            {!bankAccount && (
              <p>برای این فرستنده هیچ حساب بانکی انتخاب نشده است</p>
            )}

            <div className="d-flex flex-wrap column-gap-3">
              <NewBankAccount onSubmit={value => setBankAccount(value)} />
              <SelectBankAccountGrid
                onSubmit={value => setBankAccount(value)}
              />
            </div>
          </Fragment>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          className="buttonUi text-center btn-success-style"
          onClick={handleBankAccountPick}
        >
          تایید و ادامه
        </button>
        <button className="buttonUi btn-cancel-style" onClick={onClose}>
          خروج
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ChooseBankAccountForOrder;
